import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import { motionEffects } from './motionEffectsCompNode'
import { MotionEffectsCssFeature } from './motionEffects.types'
import { motionEffectsDomApplier } from './motionEffectsDomApplier'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'

export const motionEffectsCssFeature: MotionEffectsCssFeature = {
	featureName: 'motionEffects',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { motionEffects },
	intermediateNodes: { hasResponsiveLayout: compInfoNodes.hasResponsiveLayout },
	dataMaps: ['effects'],
	domApplier: motionEffectsDomApplier,
	parentMediaRule: 'prefers-reduced-motion: no-preference',
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(motionEffectsCssFeature)
}
export const editor: BindFeature = page
